import { client, useConfig, useElementData } from '@sigmacomputing/plugin'
import { useEffect } from 'react'
import { themeOptions, themes } from '../utilities'
import '../data-viz/components/Gauge'
  
export default function App() {

    useEffect(() => {
        client.config.configureEditorPanel([
            {
                name: "source",
                type: "element",
            },
            {
                name: "value",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: 'label',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            },
            {
                name: 'theme',
                type: 'dropdown',
                values: themeOptions
            },
            {
                name: 'helpText',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            }
        ])
    }, [])
        
    const config = useConfig()
    const sigmaData = useElementData(config.source)

    const { value, label, theme, helpText } = config
    const val = (Object.keys(sigmaData).length && value) ? sigmaData[value][0] : null

    return (
        <>
            <zero-gauge
                data-value={val}
                data-heading={label}
                data-bg={themes[theme]?.light}
                data-fill={themes[theme]?.dark}
                data-help={helpText}></zero-gauge>
        </>
    )
}
